"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.staticRenderFns = exports.render = void 0;
var render = exports.render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("a-result", {
    attrs: {
      status: "500",
      title: "服务器异常",
      "sub-title": "emm...很抱歉，系统出错了，管理员正在加紧抢修中，请稍后再试"
    },
    scopedSlots: _vm._u([{
      key: "extra",
      fn: function () {
        return [_c("a-button", {
          attrs: {
            type: "primary"
          },
          on: {
            click: _vm.toHome
          }
        }, [_vm._v(" 返回首页 ")])];
      },
      proxy: true
    }])
  });
};
var staticRenderFns = exports.staticRenderFns = [];
render._withStripped = true;